const actions = {
  SET_STATE: "jwt/SET_STATE",
  CREATE: "jwt/CREATE",
};

export default actions;
